var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlipSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2654",
    "data-name": "Group 2654",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.953,
    height: 18,
    viewBox: "0 0 15.953 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1774",
    "data-name": "Rectangle 1774",
    width: 15.953,
    height: 18,
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M14.94,0a1.2,1.2,0,0,0-.13,0H1.14A1.071,1.071,0,0,0,0,1a1.162,1.162,0,0,0,0,.127V18l3.418-2.25L5.7,18l2.278-2.25L10.254,18l2.279-2.25L15.95,18V1.127A1.068,1.068,0,0,0,14.94,0M3.838,5.109h8.236a.831.831,0,1,1,0,1.662H3.838a.831.831,0,1,1,0-1.662m8.292,5.707H3.894a.831.831,0,1,1,0-1.662h8.237a.831.831,0,1,1,0,1.662",
    transform: "translate(0.001 0)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlipSelected);
export default __webpack_public_path__ + "static/media/slip_selected.eb11cafdd82e2cccecc4b8b609fd37ce.svg";
export { ForwardRef as ReactComponent };